export class Row {
    Titolo: string;
    field_testo_export: string;
    constructor() {
        this.Titolo = '';
        this.field_testo_export = '';
    }
}

export class Pager {
    current_page: number;
    total_items: string;
    total_pages: number;
    items_per_page: number;
    constructor() {
        this.current_page = 0;
        this.total_items = '';
        this.total_pages = 0;
        this.items_per_page = 0;
    }
}

export class NodePageJoint {
    rows: Row[];
    pager: Pager;
    constructor() {
        this.rows = [];
        this.pager = new Pager();
    }
}

export class Footer {
    langcode: Langcode;
    type: any[];
    default_langcode: DefaultLangcode;
    metatag: Metatag;
    field_dettagli_universita: FieldDettagliUniversita[];
    field_logo_universita: FieldLogoUniversita[];
    field_menu_footer: Subtree[];
    field_link_social: any;
    field_dettagli_partner: FieldDettagliPartner[]
    constructor() {
        this.langcode = new Langcode();
        this.type = [];
        this.default_langcode = new DefaultLangcode();
        this.metatag = new Metatag();
        this.field_dettagli_universita = [];
        this.field_logo_universita = [];
        this.field_menu_footer = [];
        this.field_dettagli_partner = [];
    }
}

export class Langcode {
    value: string;
    constructor() {
        this.value = '';
    }
}

export class DefaultLangcode {
    value: boolean;
    constructor() {
        this.value = false;
    }
}

export class Value {
    canonical_url: string;
    title: string;
    constructor() {
        this.canonical_url = "";
        this.title = "";
    }
}

export class Metatag {
    value: Value;
    title: string;
    constructor() {
        this.value = new Value();
        this.title = "";
    }
}

export class FieldDettagliUniversita {
    value: string;
    format: string;
    processed: string;
    constructor() {
        this.value = "";
        this.format = "";
        this.processed = "";
    }
}

export class FieldDettagliPartner {
    value: string;
    format: string;
    processed: string;
    constructor() {
        this.value = "";
        this.format = "";
        this.processed = "";
    }
}

export class FieldLogoUniversita {
    target_id: number;
    alt: string;
    title: string;
    width: number;
    height: number;
    target_type: string;
    target_uuid: string;
    url: string;
    constructor() {
        this.target_id = 0;
        this.alt = "";
        this.title = "";
        this.width = 0;
        this.height = 0;
        this.target_type = "";
        this.target_uuid = "";
        this.url = "";
    }
}


export class HighlightNews {
    field_created_at: string;
    field_link_news: string;
    field_titolo: string;
    field_url_immagine: string;
    constructor() {
        this.field_created_at = "";
        this.field_link_news = "";
        this.field_titolo = "";
        this.field_url_immagine = "";
    }
}

export class Subtree {
    label: string;
    external: boolean;
    alt_view: boolean;
    enabled: boolean;
    highlight_news?: HighlightNews;
    link: string;
    text: string;
    subtree: any[];
    menu_custom?: any[];
    constructor() {
        this.label = "";
        this.external = false;
        this.alt_view = false;
        this.enabled = false;
        this.highlight_news = new HighlightNews();
        this.link = "";
        this.text = "";
        this.subtree = [];
    }
}

export class FieldLinkSocial {
    value: string;
    constructor() {
        this.value = "";
    }
}

export class FieldNomeSocial {
    value: string;
    constructor() {
        this.value = "";
    }
}

export class FieldLinkSocialHeader {
    field_link_social: FieldLinkSocial;
    field_nome_social: FieldNomeSocial;
    constructor() {
        this.field_link_social = new FieldLinkSocial();
        this.field_nome_social = new FieldNomeSocial();
    }
}

export class Header {
    langcode: Langcode;
    type: any[];
    default_langcode: DefaultLangcode;
    metatag: Metatag;
    field_link_social: FieldLinkSocialHeader[];
    field_logo_universita: FieldLogoUniversita[];
    field_main_menu: Subtree[];
    field_barra_secondaria: FieldBarraSecondaria[];
    field_barra_terziaria: FieldBarraTerziaria[];
    constructor() {
        this.langcode = new Langcode();
        this.type = [];
        this.default_langcode = new DefaultLangcode();
        this.metatag = new Metatag();
        this.field_link_social = [];
        this.field_logo_universita = [];
        this.field_main_menu = [];
        this.field_barra_secondaria = [];
        this.field_barra_terziaria = [];
    }
}

export interface FieldBarraSecondaria {
    field_colonne_menu: FieldColonneMenu[]
    field_con_link_social: FieldConLinkSocial[]
    field_titolo_elemento: FieldTitoloElemento[]
}

export interface FieldColonneMenu {
    field_descrizione_colonna: FieldDescrizioneColonna[]
    field_link_colonna: FieldLinkColonna[]
    field_titolo_colonna: FieldTitoloColonna[]
}

export interface FieldDescrizioneColonna {
    value: string
    format: string
}

export interface FieldLinkColonna {
    url: string
    label: string
}

export interface FieldTitoloColonna {
    value: string
}

export interface FieldConLinkSocial {
    value: string
}

export interface FieldTitoloElemento {
    value: string
}

export interface FieldBarraTerziaria {
    field_icona_elemento_menu: string
    field_link_correlato: FieldLinkCorrelato[]
}

export interface FieldLinkCorrelato {
    url: string
    label: string
}

export interface FieldLinkLogo {
    url: string
}

export interface FieldLinkSocial {
    field_link_social: FieldLinkSocial2[]
    field_nome_social: FieldNomeSocial[]
}

export interface FieldLinkSocial2 {
    value: string
}
export interface FieldLogoUniversium {
    target_id: number
    alt: string
    title: string
    width: number
    height: number
    target_type: string
    target_uuid: string
    url: string
}

export interface FieldMainMenu {
    label: string
    external: boolean
    link: string
    text?: string
    alt_view: boolean
    subtree: Subtree[]
    highlight_news?: HighlightNews
}

export class Nid {
    value: number;
    constructor() {
        this.value = 0;
    }
}

export class Uuid {
    value: string;
    constructor() {
        this.value = "";
    }
}

export class Vid {
    value: number;
    constructor() {
        this.value = 0;
    }
}

export class Type {
    target_id: string;
    target_type: string;
    target_uuid: string;
    constructor() {
        this.target_id = "";
        this.target_type = "";
        this.target_uuid = "";
    }
}

export class RevisionTimestamp {
    value: Date;
    format: string;
    constructor() {
        this.value = new Date();
        this.format = "";
    }
}

export class RevisionUid {
    target_id: string;
    target_type: string;
    target_uuid: string;
    url: string;
    constructor() {
        this.target_id = "";
        this.target_type = "";
        this.target_uuid = "";
        this.url = "";
    }
}

export class Status {
    value: boolean;
    constructor() {
        this.value = false;
    }
}

export class Uid {
    target_id: string;
    target_type: string;
    target_uuid: string;
    url: string;
    constructor() {
        this.target_id = "";
        this.target_type = "";
        this.target_uuid = "";
        this.url = "";
    }
}

export class Title {
    value: string;
    constructor() {
        this.value = "";
    }
}

export class Created {
    value: Date;
    format: string;
    constructor() {
        this.value = new Date();
        this.format = "";
    }
}

export class Changed {
    value: Date;
    format: string;
    constructor() {
        this.value = new Date();
        this.format = "";
    }
}

export class Promote {
    value: boolean;
    constructor() {
        this.value = false;
    }
}

export class Sticky {
    value: boolean;
    constructor() {
        this.value = false;
    }
}

export class Path {
    alias: string;
    pid: number;
    langcode: string;
    constructor() {
        this.alias = "";
        this.pid = 0;
        this.langcode = "";
    }
}

export class ContentTranslationSource {
    value: string;
    constructor() {
        this.value = "";
    }
}

export class ContentTranslationOutdated {
    value: boolean;
    constructor() {
        this.value = false;
    }
}

export class FieldLayoutRighe {
    target_id: string;
    target_type: string;
    target_uuid: string;
    url: string;
    constructor() {
        this.target_id = "";
        this.target_type = "";
        this.target_uuid = "";
        this.url = "";
    }
}

export class PageBuilder {
    nid: Nid;
    uuid: Uuid;
    vid: Vid;
    langcode: Langcode[];
    type: Type;
    revision_timestamp: RevisionTimestamp;
    revision_uid: RevisionUid;
    revision_log: any[];
    status: Status;
    uid: Uid;
    title: Title[];
    created: Created;
    changed: Changed;
    promote: Promote;
    sticky: Sticky;
    default_langcode: DefaultLangcode;
    revision_translation_affected: any[];
    metatag: Metatag;
    path: Path;
    content_translation_source: ContentTranslationSource;
    content_translation_outdated: ContentTranslationOutdated;
    field_layout_righe: FieldLayoutRighe[];
    field_metatag: any[];
    constructor() {
        this.nid = new Nid();
        this.uuid = new Uuid();
        this.vid = new Vid();
        this.langcode = [];
        this.type = new Type();
        this.revision_timestamp = new RevisionTimestamp();
        this.revision_uid = new RevisionUid();
        this.revision_log = [];
        this.status = new Status();
        this.uid = new Uid();
        this.title = [];
        this.created = new Created();
        this.changed = new Changed();
        this.promote = new Promote();
        this.sticky = new Sticky();
        this.default_langcode = new DefaultLangcode();
        this.revision_translation_affected = [];
        this.metatag = new Metatag();
        this.path = new Path();
        this.content_translation_source = new ContentTranslationSource();
        this.content_translation_outdated = new ContentTranslationOutdated();
        this.field_layout_righe = [];
        this.field_metatag = [];
    }
}

export class RowBlock {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    colonne_occupate: string;
    image: string;
    testo_alt: string;
    uid: string;
    created: string;
    testo: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.colonne_occupate = "";
        this.image = "";
        this.testo_alt = "";
        this.uid = "";
        this.created = "";
        this.testo = "";
    }
}

export class RowBuilder {
    Title: string;
    Row_blocks: RowBlock[];
    field_ancora?: string;
    constructor() {
        this.Title = "";
        this.Row_blocks = [];
        this.field_ancora = "";
    }
}

export class TranslationPath {
    Titolo: string;
    Path: string;
    Langcode: string
    constructor() {
        this.Titolo = "";
        this.Path = "";
        this.Langcode = "";
    }
}

export class RowNews {
    Titolo: string;
    Testo_news: string;
    field_immagine_cover: string;
    field_link: string;
    constructor() {
        this.Titolo = "";
        this.Testo_news = "";
        this.field_immagine_cover = "";
        this.field_link = "";
    }
}

export class News {
    rows: RowNews[];
    pager: Pager;
    constructor() {
        this.rows = [];
        this.pager = new Pager;
    }
}

export class carouselNews {
    Titolo: string;
    Testo_news: string;
    field_immagine_cover: string;
    field_link: string;
    constructor() {
        this.Titolo = "";
        this.Testo_news = "";
        this.field_immagine_cover = "";
        this.field_link = "";
    }
}

export class DataLayer {
    event?: string;
    location?: string;
    pagePath?: string;
    pageTitle?: string;
    pageType?: string;
    TypeSearch?: string;
    query?: string;
    constructor() {
        this.event = "";
        this.location = "";
        this.pagePath = "";
        this.pageTitle = "";
        this.pageType = "";
        this.TypeSearch = "";
        this.query = "";
    }
}

export class DataLayerError {
    event: string;
    status: string;
    location: string;
    referral: string;
    source_page: string;
    constructor() {
        this.event = "";
        this.location = "";
        this.status = "";
        this.referral = "";
        this.source_page = "";
    }
}

export class NewTag {
    nameTag: string;
    attributes: {
        nameAttribute: string,
        value: string
    }[];
    idTag: string;
    constructor() {
        this.nameTag = '';
        this.attributes = [];
        this.idTag = '';
    }
}

export class SetImmagini {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    descrizione?: string;
    immagine: string;
    testo_alt: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.descrizione = "";
        this.immagine = "";
        this.testo_alt = "";
    }
}

export class SetVideo {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    descrizione?: string;
    cover_video: string;
    link_video: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.descrizione = "";
        this.cover_video = "";
        this.link_video = "";
    }
};

export class SetNumeri {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    descrizione: string;
    numero: string;
    immagine: string;
    overline?: string;
    testo_alt?: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.descrizione = "";
        this.numero = "";
        this.immagine = "";
        this.overline = "";
        this.testo_alt = "";
    }
};
export class SetCard {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    descrizione?: string;
    immagine?: string;
    immagine_icona?: string;
    label_cta?: string;
    link_card?: LinkCard;
    overline: string;
    testo_alt?: string;
    titolo: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.descrizione = "";
        this.link_card = new LinkCard;
        this.overline = "";
        this.titolo = "";
        this.immagine = "";
        this.immagine_icona = "";
        this.testo_alt = "";
        this.label_cta = "";
    }
}

export class SetAlert {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    colonne_occupate: string;
    testo_formattato: string;
    tipologia_alert: string;
    titolo?: string;
    uid: string;
    created: string;
    label_cta: string;
    class?: string;
    icon: string;
    btn_color: string;
    link_cta?: LinkCard;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.colonne_occupate = "";
        this.testo_formattato = "";
        this.tipologia_alert = "";
        this.titolo = "";
        this.uid = "";
        this.created = "";
        this.label_cta = "";
        this.class = "";
        this.icon = "";
        this.btn_color = "";
        this.link_cta = new LinkCard;
    }
}


export class LinkCard {
    url: string;
    text: string;
    constructor() {
        this.url = "";
        this.text = "";
    }
}

export class SetQuoteTestimonial {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    descrizione?: string;
    foto?: string;
    quote: string;
    testo_alt?: string;
    titolo: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.descrizione = "";
        this.foto = "";
        this.quote = "";
        this.testo_alt = "";
        this.titolo = "";
    }
}
export class SetAccordion {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    testo_formattato: string;
    titolo: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.testo_formattato = "";
        this.titolo = "";
    }
}

export class SetModale {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    colonne_occupate: string;
    label_cta: string;
    testo_formattato: string;
    uid: string;
    created: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.colonne_occupate = "";
        this.label_cta = "";
        this.testo_formattato = "";
        this.uid = "";
        this.created = "";
    }
}

export class SetLogo {
    bundle: string;
    id: string;
    immagine: string;
    link: string;
    title: string;
    type: string;
    url: string;
    constructor() {
        this.bundle = "";
        this.id = "";
        this.immagine = "";
        this.link = "";
        this.title = "";
        this.type = "";
        this.url = "";
    }
}

export class SetDate {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    data: string;
    label_cta?: string;
    link_cta?: LinkCta;
    testo_formattato: string;
    colore?: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.data = "";
        this.label_cta = "";
        this.link_cta = new LinkCta;
        this.testo_formattato = "";
        this.colore = "";
    }
}

export class LinkCta {
    url: string;
    text: string;
    constructor() {
        this.url = "";
        this.text = "";
    }
}

export class SetAllegati {
    id: string;
    title: string;
    titolo: string;
    url: any;
    type: string;
    bundle: string;
    allegato: string;
    descrizione?: string;
    label: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.titolo = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.allegato = "";
        this.descrizione = "";
        this.label = "";
    }
}

export class Allegato {
    url: string;
    constructor() {
        this.url = "";
    }
}

export class SetElementiTimeline {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    data_timeline: string;
    immagine?: string;
    testo_alt?: string;
    testo_formattato?: string;
    titolo?: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.data_timeline = "";
        this.immagine = "";
        this.testo_alt = "";
        this.testo_formattato = "";
        this.titolo = "";
    }
}

export class SetPulsanti {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    label: string;
    link: Link;
    tipologia_pulsante: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.label = "";
        this.link = new Link;
        this.tipologia_pulsante = "";
    }
}

export class Link {
    url: string;
    text: string;
    constructor() {
        this.url = "";
        this.text = "";
    }
}

export class SetVisoreHero1 {
    caption: string;
    immagine: string;
    label_cta: string;
    link_cta: LinkCta;;
    titolo: string;
    constructor() {
        this.caption = "";
        this.immagine = "";
        this.label_cta = "";
        this.link_cta = new LinkCta;
        this.titolo = "";
    }
}

export class Jumbotron {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    caption: string;
    colonne_occupate: string;
    immagine: string;
    label_cta: string;
    link_cta: LinkCta;
    testo_alt: string;
    titolo: string;
    uid: string;
    created: string;
    link_a_contenuto_video: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.caption = "";
        this.colonne_occupate = "";
        this.immagine = "";
        this.label_cta = "";
        this.link_cta = new LinkCta;
        this.testo_alt = "";
        this.titolo = "";
        this.uid = "";
        this.created = "";
        this.link_a_contenuto_video = "";
    }
}

export class SetParagrafoImmagine {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    immagine: string;
    sottotitolo?: string;
    testo_formattato: string;
    titolo?: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.immagine = "";
        this.sottotitolo = "";
        this.testo_formattato = "";
        this.titolo = "";
    }
}

export class SetUm {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    tab_label: string;
    testo_formattato: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.tab_label = "";
        this.testo_formattato = "";
    }
}

export class ElencoStep {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    testo_step: string
    titolo_step?: string
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.testo_step = "";
        this.titolo_step = "";
    }
}

export class StickyBanner {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    colonne_occupate: string;
    label_cta: string;
    link_cta: LinkCta;
    testo_formattato: string;
    tipologia_banner: string;
    titolo: string;
    uid: string;
    created: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.colonne_occupate = "";
        this.label_cta = "";
        this.link_cta = new LinkCta;
        this.testo_formattato = "";
        this.tipologia_banner = "";
        this.titolo = "";
        this.uid = "";
        this.created = "";
    }
}

export class SetParagraph {
    id: string
    title: string
    url: any
    type: string
    bundle: string
    sottotitolo_breve: string
    testo_formattato: string
    titolo: string
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.sottotitolo_breve = "";
        this.testo_formattato = "";
        this.titolo = "";
    }
}

export class SetIFrame {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    codice_iframe: string;
    colonne_occupate: string;
    uid: string;
    created: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.codice_iframe = "";
        this.colonne_occupate = "";
        this.uid = "";
        this.created = "";
    }
}

export class SetIntestazione {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    colonne_occupate: string;
    sottotitolo: string;
    titolo: string;
    uid: string;
    created: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.colonne_occupate = "";
        this.sottotitolo = "";
        this.titolo = "";
        this.uid = "";
        this.created = "";
    }
}

export class SetTable {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    colonne_occupate: string;
    tabella: string;
    uid: string;
    created: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.colonne_occupate = "";
        this.tabella = "";
        this.uid = "";
        this.created = "";
    }
}

export class SetFeature {
    id: string;
    title: string;
    url: any;
    type: string;
    bundle: string;
    descrizione: string;
    titolo: string;
    link_cta: LinkCta;
    lettera?: string;
    label_cta: string;
    constructor() {
        this.id = '';
        this.title = '';
        this.url = '';
        this.type = '';
        this.bundle = '';
        this.descrizione = '';
        this.titolo = '';
        this.lettera = '';
        this.label_cta = '';
        this.link_cta = new LinkCta;
    }
}

export class RowBlockSimple {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    colonne_occupate: string;
    uid: string;
    created: string;
    items: any;
    sottotitolo_generale?: string;
    titolo_generale?: string;
    oggetto_view?: any;
    tipo_view?: any;
    label_cta: string;
    testo?: string;
    colore?: string;
    testo_di_supporto?: string;
    set_immagini?: SetImmagini[];
    set_video?: SetVideo[];
    set_alert?: SetAlert[];
    set_numeri?: SetNumeri[];
    set_card?: SetCard[];
    set_quote_testimonial?: SetQuoteTestimonial[];
    set_accordion?: SetAccordion[];
    set_date?: SetDate[];
    set_allegati?: SetAllegati[];
    set_elementi_timeline?: SetElementiTimeline[];
    set_pulsanti?: SetPulsanti[];
    set_visore_hero_1?: SetVisoreHero1[];
    set_paragrafo_immagine?: SetParagrafoImmagine[];
    set_ta?: SetUm[];
    elenco_step?: ElencoStep[];
    set_feature?: SetFeature[];
    set_elementi_modale?: SetModale[];
    set_loghi?: SetLogo[];
    visualizza_come_carousel?: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.colonne_occupate = "";
        this.uid = "";
        this.created = "";
        this.sottotitolo_generale = "";
        this.titolo_generale = "";
        this.oggetto_view = "";
        this.tipo_view = "";
        this.label_cta = "";
        this.testo = "";
        this.colore = "";
        this.testo_di_supporto = "";
        this.set_immagini = [];
        this.set_video = [];
        this.set_numeri = [];
        this.set_card = [];
        this.set_quote_testimonial = [];
        this.set_accordion = [];
        this.set_date = [];
        this.set_allegati = [];
        this.set_elementi_timeline = [];
        this.set_pulsanti = [];
        this.set_visore_hero_1 = [];
        this.set_paragrafo_immagine = [];
        this.set_ta = [];
        this.elenco_step = [];
        this.set_feature = [];
        this.set_elementi_modale = [];
        this.set_loghi = [];
        this.visualizza_come_carousel = "";
    }
}

export class RowSimple {
    Row_blocks: RowBlockSimple[];
    field_ancora: string;
    constructor() {
        this.Row_blocks = [];
        this.field_ancora = "";
    }
}
;
export class IframeModel {
    width?: string;
    height?: string;
    src: string;
    style?: string;
    allow?: string;
    class?: string;
    url?: string;
    constructor() {
        this.width = '';
        this.height = '';
        this.src = '';
        this.style = '';
        this.allow = '';
        this.class = '';
        this.url = '';
    }
}

export class AnchorModel {
    idRow: string;
    labelRow: string;
    position: number;
    constructor() {
        this.idRow = '';
        this.labelRow = '';
        this.position = 0;
    }
}

export class HighlightNew {
    created: string;
    field_created_at: string;
    field_titolo: string;
    field_sottotitolo: string;
    field_immagine: string;
    field_immagine_importata: string;
    field_layout_righe: FieldLayoutRighe2[];
    field_tassonomia_area_universita: FieldTassonomiaAreaUniversium[];
    field_tassonomia_dipartimento: string;
    field_tags: FieldTag[];
    field_tassonomia_tipologia: FieldTassonomiaTipologum[];
    field_tipo_di_corso?: string;
    field_classe_di_laurea?: string;
    field_lingua?: string[];
    constructor() {
        this.field_created_at = '';
        this.created = '';
        this.field_titolo = '';
        this.field_sottotitolo = '';
        this.field_immagine = '';
        this.field_immagine_importata = '';
        this.field_layout_righe = [];
        this.field_tassonomia_area_universita = []
        this.field_tassonomia_dipartimento = '';
        this.field_tipo_di_corso = '';
        this.field_classe_di_laurea = '';
        this.field_tags = []
        this.field_tassonomia_tipologia = []
        this.field_lingua = []
    }
}
export class FieldLayoutRighe2 {
    id: string;
    title: string;
    url: string;
    type: string;
    bundle: string;
    blocchi_riga: string[];
    uid: string;
    created: string;
    constructor() {
        this.id = "";
        this.title = "";
        this.url = "";
        this.type = "";
        this.bundle = "";
        this.blocchi_riga = [];
        this.uid = "";
        this.created = "";
    }
}

export class FieldTassonomiaAreaUniversium {
    id: string;
    name: string;
    constructor() {
        this.id = "";
        this.name = "";
    }
}

export class FieldTag {
    id: string;
    name: string;
    constructor() {
        this.id = "";
        this.name = "";
    }
}

export class FieldTassonomiaTipologum {
    id: string;
    name: string;
    constructor() {
        this.id = "";
        this.name = "";
    }
}

export class RegistrazioneAvvisi {
    aree_universita: AreeUniversita[];
    corsi_di_laurea: CorsiDiLaurea[];
    docenti: Docenti[];
    constructor() {
        this.aree_universita = [];
        this.corsi_di_laurea = [];
        this.docenti = [];
    }
  }
  
  export class AreeUniversita {
    id: string;
    name: string;
        constructor() {
        this.id = "";
        this.name = "";
    }
  }
  
  export class CorsiDiLaurea {
    id: string;
    name: string;
    constructor() {
        this.id = "";
        this.name = "";
    }
  }
  
  export class Docenti {
    value: string;
    label: string;
    related_courses: string[];
    constructor() {
        this.value = "";
        this.label = "";
        this.related_courses = [];
    }
  }

  export class SendRegistrazioneAvvisi {
    mode: string;
    email: string;
    corsiDiLaureaIds?: number[];
    areeUniversitaIds?: number[];
    docentiIds?: number[];
    constructor() {
        this.mode = "";
        this.email = "";
        this.corsiDiLaureaIds = [];
        this.areeUniversitaIds = [];
        this.docentiIds = [];
    }
  }

  export class DocentiPub {
    title: string;
    link: string;
    description: string;
    author: string;
    guid: string;
    pubDate: string;
    constructor() {
        this.title = "";
        this.link = "";
        this.description = "";
        this.author = "";
        this.guid = "";
        this.pubDate = "";
    }
  }

  export interface Breadcrumb {
    label: string;
    url?: string;
  }